import { useLocalStorage } from './useLocalStorage';
import type { Note } from '../types';

export function useNotes() {
  const [notes, setNotes] = useLocalStorage<Note[]>('dtf-wizard-notes', []);

  const addNote = (note: Omit<Note, 'id' | 'createdAt' | 'updatedAt'>) => {
    const newNote: Note = {
      ...note,
      id: `note-${Date.now()}`,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    };
    setNotes(prev => [newNote, ...prev]);
    return newNote.id;
  };

  const updateNote = (id: string, updates: Partial<Omit<Note, 'id' | 'createdAt'>>) => {
    setNotes(prev => prev.map(note => 
      note.id === id 
        ? { ...note, ...updates, updatedAt: new Date().toISOString() }
        : note
    ));
  };

  const deleteNote = (id: string) => {
    setNotes(prev => prev.filter(note => note.id !== id));
  };

  const getNoteById = (id: string) => {
    return notes.find(note => note.id === id);
  };

  const getNotesByIssueId = (issueId: string) => {
    return notes.filter(note => note.issueId === issueId);
  };

  const getNotesByCardId = (cardId: string) => {
    return notes.filter(note => note.cardId === cardId);
  };

  const getGeneralNotes = () => {
    return notes.filter(note => !note.issueId && !note.cardId);
  };

  return {
    notes,
    addNote,
    updateNote,
    deleteNote,
    getNoteById,
    getNotesByIssueId,
    getNotesByCardId,
    getGeneralNotes
  };
}
